import React from 'react';
import { styled } from 'styled-components';
import SvgChevron from '../../../../play-core/icons/Chevron';
import { Colors, hexToRGB } from '../../../../play-core/styles/Colors';
import { Device } from '../../../../play-core/styles/Device';
import { zIndex } from '../../../../play-core/styles/z-index';
import { jsx as _jsx } from "react/jsx-runtime";
export const buttonSize = 52;
export const ScrollButton = ({
  direction,
  onClick
}) => /*#__PURE__*/_jsx(Container, {
  style: {
    [direction]: 0
  },
  children: /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    direction: direction,
    "aria-label": `Scroll ${direction}`,
    children: /*#__PURE__*/_jsx(ButtonLayout, {
      children: /*#__PURE__*/_jsx(SvgChevron, {
        orientation: direction
      })
    })
  })
});
const Container = styled.div.withConfig({
  displayName: "ScrollButton__Container",
  componentId: "sc-8uj4w7-0"
})(["display:flex;align-items:center;width:", "px;height:", "px;position:absolute;top:0;height:100%;z-index:", ";", "{pointer-events:none;}"], buttonSize, buttonSize, zIndex.popup, Device.touch);
const Button = styled.button.withConfig({
  displayName: "ScrollButton__Button",
  componentId: "sc-8uj4w7-1"
})(["width:", "px;height:", "px;background-color:", ";opacity:0.85;transition:opacity ease-in;&:hover{background-color:", ";opacity:0.95;}", "{background-color:transparent;background:linear-gradient( to right,", ",", " );}"], buttonSize, buttonSize, Colors.GREY_3a3a3a, Colors.GREY_454545, Device.touch, props => hexToRGB(Colors.DARK_202020, props.direction === 'left' ? 0.8 : 0.0), props => hexToRGB(Colors.DARK_202020, props.direction === 'left' ? 0.0 : 0.8));
const ButtonLayout = styled.div.withConfig({
  displayName: "ScrollButton__ButtonLayout",
  componentId: "sc-8uj4w7-2"
})(["display:flex;justify-content:center;align-items:center;height:100%;width:100%;color:", ";font-size:16px;transition:all 0.2s ease-in-out;", "{display:none;}"], Colors.WHITE, Device.touch);